module.exports = __webpack_public_path__ + "static/img/2.7b711c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 0